// extracted by mini-css-extract-plugin
export default {"frameworkSelector":"p_cq","option":"p_cx","showSelected":"p_cy","selected":"p_cz","fullWidth":"p_cB"};